import React, { Component } from 'react';
import { Form } from './Form';
import Header from '../Header/Header';
import { Data } from '../../shared/Types';
import FormCard from './FormCard/FormCard';
import uniqid from 'uniqid';

import './Form.scss';

interface FormPageProps {
  getAllFormValues?: (value: boolean, data: Data, cardsData: object[]) => void;
  avatarSrc?: (fileSrc: string) => void;
}

interface FormPageState {
  isValidCard: boolean;
  data: Data;
}

export default class FormPage extends Component<FormPageProps, FormPageState> {
  cardsData: Data[];

  constructor(props: FormPageProps) {
    super(props);

    this.state = {
      isValidCard: false,
      data: {
        firstname: '',
        lastname: '',
        country: '',
        date: '',
        agreement: false,
        male: '',
        avatar: '',
      },
    };

    this.cardsData = [];
  }

  handleSubmit = (value: boolean, formValues: Data, cardsData: Data[]) => {
    this.setState({ isValidCard: value, data: formValues });
    this.cardsData = cardsData;
  };

  render() {
    return (
      <div data-testid="form-page">
        <Header page="Form page" />
        <Form getAllFormValues={this.handleSubmit} />
        <div className="wrapper form__cards-container">
          {this.state.isValidCard &&
            this.cardsData.map((card) => (
              <FormCard
                key={uniqid()}
                lastname={card.lastname}
                firstname={card.firstname}
                male={card.male}
                country={card.country}
                date={card.date}
                agreement={card.agreement}
                imageSrc={card.avatar}
                data-testid="form-card"
              />
            ))}
        </div>
      </div>
    );
  }
}
